import { render, staticRenderFns } from "./VoteResult.vue?vue&type=template&id=3d96334e&"
import script from "./VoteResult.vue?vue&type=script&lang=js&"
export * from "./VoteResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports